
import React from "react";

import { connect } from 'react-redux';
import { deleteEntry,countsDontCounts } from '../actions';

import Pagination from '../components/moreComponents/Pagination' 
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  CardFooter,
} from "reactstrap";

import NotificationAlert from "react-notification-alert";


import TableRow from '../components/moreComponents/TableRow'
import IncludeHelpModal from '../components/moreComponents/IncludeHelpModal'
import WeekPrintModal from '../components/moreComponents/WeekPrintModal'
import {tableBody,filterActivitiesByType,filterActivitiesBySubType,filterActivitiesByInclusion,sortActivitiesBy } from "../helperFunctions/trainingHistory";

class RegularTables extends React.Component {

  state = {currentPage:1,postsPerPage:20,type:'All',subType:'All',include:'All',sortBy:'Date',asc:'false'}
  
  notify(place,message) {
    if (!message){
      return ""
    }
    var color = message[0];
    if (color === "logout"){
      localStorage.clear()
      window.location.replace("/login")
    }
    var type;
    switch (color) {
      case 'success':
        type = "success";
        break;
      case 'danger':
        type = "danger";
        break;
      case 'warning':
        type = "warning";
      default:
        break;
    }
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div style={{height:'70px'}}>
            {message[1]}
          </div>
          
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 1,
    };
    this.refs.notificationAlert.notificationAlert(options);
  }
  paginate = (number) => this.setState({currentPage:number})
  deleteItem = (target) =>{
    //console.log(target.parentNode.parentNode.id)
    this.props.deleteEntry(target.parentNode.parentNode.id)
  } 
  changeCountForFitness = (target) => {
    this.props.countsDontCounts(target.parentNode.parentNode.id)
    //console.log(target.parentNode.parentNode.id)
  }
  componentDidUpdate(prevProps){
    if(prevProps.message.message !== this.props.message.message && this.props.message.message){
        this.notify("bl",this.props.message.message)
    }
  }
  render() {
    //console.log(this.props.activities.entries)
    const activities = this.props.activities.entries
    const thead = ["Type","Sub Type","Name","Date", "Duration", "Distance","Speed", "Avg Hr","Perf index","Stress Score","Total elev gain","Include","Delete"];
    const activitiesSorted = sortActivitiesBy(activities,this.state)
    let activitiesFiltered = filterActivitiesByType(activitiesSorted,this.state)
    activitiesFiltered = filterActivitiesBySubType(activitiesFiltered,this.state)
    activitiesFiltered = filterActivitiesByInclusion(activitiesFiltered,this.state)
    //console.log(activitiesFiltered)
    var tbody = tableBody(activitiesFiltered)
    //console.log(tbody)
    //tbody = tbody.reverse()

    const indexOfLastPost = this.state.currentPage*this.state.postsPerPage
    const indexOfFirstPost = indexOfLastPost-this.state.postsPerPage
    const currentPosts = tbody.slice(indexOfFirstPost,indexOfLastPost)
    return (
      <>
        <div className="content" style={{marginTop:"25px",color:"white",fontSize:'12px'}}>
        <NotificationAlert ref="notificationAlert" />
          <Row>
            <Col xs={12}>
              <Card className="card-plain">
                <CardHeader>
                  <CardTitle tag="h4">Training History</CardTitle>
                  <p className="category"> Activity data<IncludeHelpModal/></p>
                </CardHeader>
              
               
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        {thead.map((prop, key) => {
                          if (key === thead.length - 1)
                            return (
                              <th key={key} className="text-right">
                                {prop}
                              </th>
                            );
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    
                    </thead>
                    <tbody>
                      {currentPosts.map( activity  => {
                        return (
                          <TableRow activity={activity} measurementSystem={this.props.auth.measurementSystem} deleteEntry={(e)=>this.deleteItem(e.target)} changeCountForFitness={(e)=>this.changeCountForFitness(e.target)}/>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
                
              </Card>
            </Col>
          </Row>
          <Row>
            
            <Col xs={12} md={12} lg={12}>
              
              <Card className="card-chart" style={{backgroundColor: 'rgb(33,33,33)',color: '#FFFFFF'}}>
                <Row style={{marginTop:'20px'}}>
                  <Col xs={8} style={{display:'flex',flexWrap:'wrap'}}>
                  <Pagination style={{flexWrap:'wrap'}} paginate={this.paginate} postsPerPage={this.state.postsPerPage} totalPosts={tbody.length}/>
                  </Col>
                  
                </Row>
                
                <CardHeader>
                  <h5 className="card-category"></h5>
                  <CardTitle tag="h4">Filter by</CardTitle>
                    <Row>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Type</h5>
                          <CardTitle tag="h4">
                            <Input type="select" value={this.state.type} onChange={(e)=>this.setState({type:e.target.value,currentPage:1})} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                              <option value ="All">All</option>
                              <option value ="Run">Run</option>
                              <option value ="Ride">Ride</option>
                              <option value ="Swim">Swim</option>
                              <option value ="Other">Other</option>
                                         
                            </Input>
                          </CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                        
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">SubType</h5>
                          <CardTitle tag="h4">
                            <Input type="select" value={this.state.subType} onChange={(e)=>this.setState({subType:e.target.value,currentPage:1})} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                              <option disabled style={{fontStyle:'italic'}}>Only for running activities for now</option> 
                              <option value ="All">All</option>
                              <option value ="Race">Race</option>
                              <option value ="Interval">Interval</option>
                              <option value ="Threshold">Treshold</option>
                              <option value ="Aerobic II">Aerobic II</option>
                              <option value ="Aerobic I">Aerobic I</option>
                              <option value ="Base">Base</option>
                              <option value ="None">Other</option>
                                         
                            </Input>

                          </CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">

                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Include</h5>
                          <CardTitle tag="h4">
                          <Input type="select" value={this.state.include} onChange={(e)=>this.setState({include:e.target.value,currentPage:1})} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                              <option disabled style={{fontStyle:'italic'}}>Activities that are included or excluded from perf. index calculation</option> 
                              <option value ="All">All</option>
                              <option value ="True">Only included</option>
                                     
                            </Input>
                          </CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                        
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={4}>
                      <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Sort By</h5>
                          <CardTitle tag="h4">
                            <Input type="select" value={this.state.sortBy} onChange={(e)=>this.setState({sortBy:e.target.value})} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                                <option disabled style={{fontStyle:'italic'}}>Activities that are included or excluded from perf. index calculation</option> 
                                <option value ="Date">Date</option>
                                <option value ="Duration">Duration</option>
                                <option value ="Distance">Distance</option>      
                                <option value ="Perf Index">Perf Index</option>
                                <option value ="Stress Score">Stress Score</option>
                                <option value ="Elevation">Elevation</option>
                                           
                            </Input>
                            <Input type="select" value={this.state.asc} onChange={(e)=>this.setState({asc:e.target.value})} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936',marginTop:'10px'}}>
                                <option disabled style={{fontStyle:'italic'}}>Activities that are included or excluded from perf. index calculation</option> 
                                <option value ='true'>Ascenting</option>
                                <option value ='false'>Descenting</option>         
                            </Input>
                          </CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                        
                          </div>
                        </CardFooter>
                        </Card>
                      </Col>
                      <Col xs={12} md={4}>
                       
                  
                      </Col>
                      
                    </Row>
                    <Row>
                      {activities.length >10 ?
                        <WeekPrintModal activities={activities}/>
                        :
                        ''
                      }
                      
                    </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                  <Row style={{marginTop:'20px'}}>
                  
                  <Col xs={4}>
            
                  </Col>
                  
                  <Col xs={4}>
                    
                  </Col>
                </Row>
                  </div>
                </CardFooter>
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
          
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) =>{
  //console.log("state in training History",state)
  return {activities:state.activities,message:state.message,auth:state.auth}
}


export default connect(mapStateToProps,{deleteEntry,countsDontCounts})(RegularTables);
